import { Splide } from '@splidejs/splide';

export default () => {
	const sections = document.querySelectorAll('.look');
	
	sections.forEach(function(section) {
		const sliderWrappers = section.querySelectorAll('.splide');

		sliderWrappers.forEach(function(sliderEl) {
			const slides = sliderEl.querySelectorAll('.splide__slide');
			if (slides.length < 3) return;

			const splide = new Splide( sliderEl, {
				type: 'loop',
				focus: 'center',
				pagination: false,
				arrows: false,
				speed: 400,
				destroy: true,
				drag: 'free',
				
				breakpoints: {
					1023: {
						fixedWidth: '50vw',
						perMove: 1,
						destroy: false
					},
					// 767: {
						
					// },
				}
			});

			splide.mount();
		});
	});
}